var productGallery = {
	selector: '.product-gallery',
    init: function() {
        var self = this,
        $productGallery = $( self.selector );

        $productGallery.each( function() {
            var $this = $( this ),
            $images = $this.find( self.selector + '__images' ),
            $thumbnails = $this.find( self.selector + '__thumbnail' );

            $images.on( 'init', function() {
                if ( $( '.single-product--simple' ).length > 0 ) {
                    $productGallery.addClass( 'loaded' );
                }
            } );

            $images.slick( {
                arrows: false,
                slidesToScroll: 1,
                infinite: false,
                fade: true
            } );

            $thumbnails.eq( $images.slick( 'slickCurrentSlide' ) ).addClass( 'active' );

            $images.on( 'beforeChange', function( e, slick, currentSlide, nextSlide ) {
                $thumbnails.removeClass( 'active' );
                $thumbnails.eq( nextSlide ).addClass( 'active' );
            } );

            $thumbnails.on( 'click', function() {
                var $thumbnail = $( this ),
                index = $thumbnail.index();

                $images.slick( 'slickGoTo', index );
            } );
        } );
    }
};

export { productGallery };